/**
 * © Copyright IBM Corp. 2021, 2023
 * SPDX-License-Identifier: Apache-2.0
 */

import getReactRenderer from './ReactRenderer';

export default getReactRenderer;
